// src/containers/TheHeader.js
import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import {
  CHeader,
  CToggler,
  CHeaderBrand,
  CHeaderNav,
  CBreadcrumbRouter,
  CImg
} from '@coreui/react'

// ❌ NÃO: import { TheHeaderDropdown } from './index'
// ✅ SIM: import direto do arquivo
import TheHeaderDropdown from './TheHeaderDropdown'

const TheHeader = () => {
  const dispatch = useDispatch()
  const sidebarShow = useSelector(state => state.sidebarShow)
  const routes = useSelector(state => state.routes)

  const toggleSidebar = () => {
    const val = [true, 'responsive'].includes(sidebarShow) ? false : 'responsive'
    dispatch({ type: 'set', sidebarShow: val })
  }

  const toggleSidebarMobile = () => {
    const val = [false, 'responsive'].includes(sidebarShow) ? true : 'responsive'
    dispatch({ type: 'set', sidebarShow: val })
  }

  return (
    <CHeader
      withSubheader
      className="position-relative d-flex align-items-center justify-content-between border-0"
      style={{
        background:
          'linear-gradient(90deg, rgb(255 255 255 / 72%) 0%, rgb(4 4 97 / 29%) 46%, rgb(255 255 255 / 70%) 100%)',
      }}
    >
      {/* Lado Esquerdo: Toggler + Breadcrumb */}
      <div className="d-flex align-items-center">
        <CToggler
          inHeader
          className="ml-md-3 d-lg-none"
          onClick={toggleSidebarMobile}
        />
        <CToggler
          inHeader
          className="ml-3 d-md-down-none"
          onClick={toggleSidebar}
          style={{ color: 'black' }}
        />
        <CHeaderNav className="d-md-down-none ml-3">
          <CBreadcrumbRouter
            className="border-0 c-subheader-nav m-0 px-0 px-md-3 breadcrumb-custom"
            routes={routes}
            style={{ fontWeight: 'bold' }}
          />
        </CHeaderNav>
      </div>

      {/* Logo Central Absoluto */}
      <CHeaderBrand
        className="position-absolute w-100"
        // ⚠️ Se quiser que o link do logo seja clicável, remova pointerEvents:'none'
        style={{ left: 0, top: 0, bottom: 0, pointerEvents: 'none', zIndex: 0 }}
      >
        <div style={{display:'flex', alignItems:'center'}}>
          <CImg src="logo.png" style={{ height: '50px', width: 'auto' }} alt="Logo" />
          <h1 style={{marginLeft:'20px'}}>|</h1>
          <img src="FullServiceHead.png" alt="Full Service" style={{ height: '90px', width: 'auto' }}/>
  
        </div>
      </CHeaderBrand>

      {/* Lado Direito: Dropdown */}
      <div className="d-flex align-items-center">
        <CHeaderNav className="px-3">
          < TheHeaderDropdown />
        </CHeaderNav>
      </div>
    </CHeader>
  )
}

export default TheHeader
